import React, { useEffect, useState } from 'react';
import { Radar } from 'react-chartjs-2';
import { COLORS } from '../../consts';

const RadarChart = ({ radarData, currentMetric }) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    if (radarData) {
      setData({
        labels: radarData.labels || [],
        datasets: radarData.data?.map((radar, idx) => {
          return {
            label: radar.name || '',
            data: radar.val || [],
            fill: false,
            backgroundColor: COLORS.graphColors[idx],
            borderColor: COLORS.graphColors[idx],
            borderWidth: 2,
          };
        }),
      });
    } else {
      setData({
        labels: [],
        datasets: [],
      });
    }
  }, [radarData]);

  return (
    <div
      id='radarchart'
      className='w-full flex flex-col justify-center items-center mb-10 p-4 rounded-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-101'
    >
      <p className='w-full text-center font-IBMPlexSansBold text-2xl mb-5 heading'>
        {currentMetric}
      </p>
      <div className='w-[600px]'>
        <Radar data={data} />
      </div>
    </div>
  );
};

export default RadarChart;
